const STEP_INDEX_MAP = {
  existingVisa: 'selectedExistingVisa',
  sourceCountry: 'selectedSourceCountry',
  jobPosition: 'selectedJobPosition',
  citizenship: 'selectedCitizenship',
  requirements: 'requirementResponses',
};

export default STEP_INDEX_MAP;
